export const MARKET_ACTIVE_ROUTE = 'MARKET_ACTIVE_ROUTE'
export const MARKET_ACTIVE_ROUTE_CHILD = 'MARKET_ACTIVE_ROUTE_CHILD'
export const SET_SHOW_FOOTER = 'SET_SHOW_FOOTER'